module.exports = __webpack_public_path__ + "static/img/7.fd8ccd2c.png";